export default "__VITE_ASSET__BF7D4eVO__"